export default Object.freeze({
  TRANSFER: 'TRANSFER',
  CHEQUE: 'CHEQUE',
  CARD: 'CARD',
});
